import clsx from "clsx";

interface SkeletonProps {
	className?: string;
}

const Skeleton = ({ className }: SkeletonProps) => {
	return (
		<div
			className={clsx(
				"animate-pulse rounded-lg bg-slate-100 dark:bg-slate-700",
				className,
			)}
		/>
	);
};

export default Skeleton;
